import React,{useState,useEffect} from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';

const DashboardThemeCard =({title,theme,showScreens,selectTheme})=>{
      const dispatch = useDispatch();
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
     ;
return(<>
<div style={{  display: "flex", alignItems: "center",justifyContent: "center"}} >
<div align="left" className="itemCourseOuter" style={{marginBottom:"40px",height:"380px",width:"240px"}}> 
          
          <div  className="whatToDoNextItemCardInner" ><div style={{background:"rgba(86, 82, 131,0.1)",width:"50px",height:"50px",borderRadius:"50%",
                float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}><GalleryHorizontal size={32}  color="rgba(86, 82, 131,1)"/></div> 
          
           <h4>{title}</h4> 
          </div><div className="theme-bottom-show-hover">
          <div className="theme-bottom-show-bottom-card">
          
          
          
          <button onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} onClick={()=>{ 
                selectTheme(theme)
            
             }}  
           className="EditBtnItemCard"  type="submit"
           id="signupBtn"> <span className="c" >Select Theme </span> </button> 
            </div>  </div>
          <div className="set-expiry-card-bottom">
          <div></div>
          </div>   </div>
          </div>
</>)
}

export default DashboardThemeCard;
